import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { VENEER_INVENTORY_ISSUE_ORDER } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// ✅ Lazy-load component pages
const VeneerInventoryList = lazy(() => import("app/pages/Inventory/veneerInventory/List"));
const AddVeneerStock = lazy(() => import("app/pages/Inventory/veneerInventory/Add"));
const EditVeneerStock = lazy(() => import("app/pages/Inventory/veneerInventory/Edit"));
const ViewDetails = lazy(() => import("app/pages/Inventory/veneerInventory/List/Approval/ViewDetails"));
const VeneerIssueOrder = lazy(() => import("app/pages/Inventory/veneerInventory/VeneerIssueOrder"));

// ✅ Route config using LoadablePage
export const veneerInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "veneer_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/veneer",
        element: LoadablePage(VeneerInventoryList),
      },
      {
        path: "/inventory/veneer/add",
        element: LoadablePage(AddVeneerStock),
      },
      {
        path: "/inventory/veneer/edit",
        element: LoadablePage(EditVeneerStock),
      },
      {
        path: "/inventory/veneer-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: VENEER_INVENTORY_ISSUE_ORDER,
        element: LoadablePage(VeneerIssueOrder),
      },
    ],
  },
];
